@if (!state.loading && !state.error && isEntryBtnValidated) {
    <div class="banner-block-place" [hidden]="!showBanners"></div>
    <div [ngClass]="!isEntryBtnAvailable ? 'ribbon-block-place' : 'ribbon-block-place-btn'">
        @if (ribbon) {
            <lazy-component
                moduleUri="@sharedModule/components/moduleRibbon/module-ribbon.module#RibbonModule"
                [inputs]="{ ribbon: ribbon }"
                entryComponent="ModuleRibbonComponent">
            </lazy-component>
        }
    </div>
} @else {
    <div class="banner-block-place" [hidden]="!showBanners"></div>
    <div class="ribbon-block-place"></div>
}
<outlet-status [state]="state">
    <request-error (reloadFn)="reloadComponent()"></request-error>
</outlet-status>

@if (!state.loading && !state.error && isEntryBtnValidated) {
    <router-outlet></router-outlet>
}
